// 查看他人的 profile
import React, {useContext, useEffect, useState} from "react";
import "./CustomProfile.css";
import {IUserInfo} from "../../common/utils/http/IResponse.ts";
import useLoading from "../../providers/loadingContext/useLoading.ts";
import {ThemeContext} from "../../providers/themeContext/theme-context.tsx";
import {ToastContext} from "../CustomToast/ToastProvider.tsx";
import {apiService} from "../../common/utils/http/api-service.ts";
import CustomPopup from "../CustomPopup";
import CustomAvatar from "../CustomAvatar/CustomAvatar.tsx";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    userId: string | null;
}

const CustomProfile: React.FC<Props> = ({
                                            isOpen,
                                            onClose,
                                            userId
                                        }) => {
    const {showLoading, hideLoading} = useLoading();
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    const {addToast} = useContext(ToastContext);

    const [userInfo, setUserInfo] = useState<IUserInfo | null>(null);


    useEffect(() => {
        if (isOpen) {
            // 加载数据
            if (userId) {
                loadUserData(userId)
            }
        }
    }, [isOpen]);

    // 加载用户数据
    const loadUserData = async (userId: string) => {
        try {
            showLoading()
            const response = await apiService.getUserInfoById(userId)
            if (response.code === 200) {
                // 处理数据
                setUserInfo(response.data);
            } else {
                addToast({type: 'error', message: `${response.message}`})
            }
        } catch (e) {
            addToast({type: 'error', message: `${e}}`})
        } finally {
            hideLoading()
        }
    }


    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="my-profile-page-container">
                <img className="profile-background-img" src={imgUrls.profileBgPic} alt="img"/>
                <div className="profile-header">
                    <div className="profile-title my-roboto-medium">Profile</div>
                    <img onClick={onClose} className="profile-close-btn"
                         src={imgUrls.closeBtnWhiteUrl}
                         alt="close"/>
                </div>
                <div
                    className="height-66 width-66 margin-left-right-auto margin-top-20 position-relative">
                    <CustomAvatar className="height-66 width-66 padding-all-2 bg-color-white border-radius-round"
                                  avatar={userInfo?.avatarUrl}
                                  avatarFrame={userInfo?.avatarFrameUrl}
                    />
                </div>
                <div className="user-name my-roboto-medium">
                    {userInfo?.cgtnName ?? userInfo?.guestName ?? "Guest_01"}
                </div>
                {/*国家*/}
                <div
                    className="margin-top-3 border-radius-34 padding-top-3 display-flex-row display-flex-justify-content-center display-flex-align-items-center padding-bottom-3 bg-light-blue height-22 min-width-104 max-width-310 margin-left-right-auto text-center font-size-14 color-blue my-roboto-regular">
                    <div className="max-width-290 margin-left-8 margin-right-8 text-ellipsis ">
                        {userInfo?.country ?? "Country/Region"}
                    </div>
                </div>
                <div
                    className="margin-top-8 font-size-14 height-29 width-333 text-center display-flex-align-content margin-left-right-auto my-roboto-medium bg-color-grey border-radius-6">
                    Profile Info
                </div>
                <div>
                    <div className="stats-main-container margin-left-right-auto">
                        <div
                            className="margin-top-6 display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                            <div className="grid-item margin-top-bottom-auto">
                                <div
                                    className="font-size-20 my-roboto-bold">{userInfo?.userGame.totalGamePlayed ?? 0}</div>
                                <div className="subtitle my-roboto-regular">Total</div>
                            </div>
                            <div className="grid-item margin-left-6">
                                <div
                                    className="font-size-20 my-roboto-bold">{userInfo?.userGame?.averageGuess ?? 0}</div>
                                <div className="subtitle my-roboto-regular">Average Guess</div>
                            </div>
                        </div>
                        <div
                            className="margin-top-6 display-flex-row display-flex-align-items-center display-flex-justify-content-center">

                            <div className="grid-item">
                                <div
                                    className="font-size-20 my-roboto-bold">{userInfo?.userGame?.dailyGameWinNum ?? 0}</div>
                                <div className="subtitle my-roboto-regular">Wins</div>
                            </div>
                            <div className="grid-item margin-left-6">
                                <div
                                    className="font-size-20 my-roboto-bold">{userInfo?.userGame?.aiChallengeBestStreak ?? 0}</div>
                                <div className="subtitle my-roboto-regular">Best Streak</div>
                            </div>
                        </div>
                    </div>
                    {/*徽章列表部分*/}
                    <div
                        className="position-relative margin-top-6 border-radius-10 height-175 width-333 bg-light-green-container margin-left-right-auto">
                        <div className="font-size-16 my-roboto-bold text-center padding-top-14">Achievements</div>
                        <div
                            className="height-119 width-306 margin-top-10 margin-left-right-auto display-flex-row">
                            {(userInfo?.medals && userInfo?.medals.length > 0) ?
                                <div
                                    className="display-flex-column border-radius-6 bg-color-white width-97 height-119 display-flex-align-items-center display-flex-justify-content-center">
                                    <img src={userInfo?.medals[0].medalUrl}
                                         className="height-73 width-73 object-fit-contain" alt="pic"/>
                                    <div
                                        className="margin-top-3 font-size-14 my-roboto-medium text-center">{userInfo?.medals[0].medalName}</div>
                                </div>
                                : <div
                                    className="display-flex-column border-radius-6 bg-color-white width-97 height-119 margin-left-7 display-flex-justify-content-center display-flex-align-items-center">
                                    <img src={imgUrls.profileEmptyImg} className="height-73 width-73"
                                         alt="pic"/>
                                </div>}
                            {(userInfo?.medals && userInfo?.medals.length > 1) ? <div
                                className="display-flex-column border-radius-6 bg-color-white width-97 height-119 margin-left-7 display-flex-justify-content-center display-flex-align-items-center">
                                <img src={userInfo?.medals[1].medalUrl}
                                     className="height-73 width-73 object-fit-contain" alt="pic"/>
                                <div
                                    className="margin-top-3 font-size-14 my-roboto-medium  text-center">{userInfo?.medals[1].medalName}</div>
                            </div> : <div
                                className="display-flex-column border-radius-6 bg-color-white width-97 height-119 margin-left-7 display-flex-justify-content-center display-flex-align-items-center">
                                <img src={imgUrls.profileEmptyImg} className="height-73 width-73"
                                     alt="pic"/>
                            </div>}
                            {userInfo && userInfo?.medals.length > 2 ? <div
                                    className="display-flex-column border-radius-6 bg-color-white width-97 height-119 margin-left-7 display-flex-justify-content-center display-flex-align-items-center">
                                    <img src={userInfo?.medals[2].medalUrl}
                                         className="height-73 width-73 object-fit-contain" alt="pic"/>
                                    <div
                                        className="margin-top-3 font-size-14 my-roboto-medium text-center">{userInfo?.medals[2].medalName}</div>
                                </div> :
                                <div
                                    className="display-flex-column border-radius-6 bg-color-white width-97 height-119 margin-left-7 display-flex-justify-content-center display-flex-align-items-center">
                                    <img src={imgUrls.profileEmptyImg} className="height-73 width-73"
                                         alt="pic"/>
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </CustomPopup>
    );
}

export default CustomProfile;